import * as React from 'react';
import { makeStyles, createStyles, Theme, Box } from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';
import { OutDebt } from '../../generated/graphql';
import ACPKDebtsSummaryTable from '../NegotiationDebts/ACPKDebtsSummaryTable';
import useDictionary from '../../dictionaries/context/useDictionary';
import Btn from '../Btn/Btn';
import { portalRootUrl } from '../../containers/Portal/portalRootUrl';

interface AccordionNegOptionsAcpkChildProps {
  parentDebt: OutDebt;
}

const AccordionNegOptionsAcpkChild: React.FC<AccordionNegOptionsAcpkChildProps> = (props) => {
  const { parentDebt } = props;
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  const classes = useStyles();
  const { gT } = useDictionary();

  return (
    <Box className={classes.root}>
      <ACPKDebtsSummaryTable
        debt={parentDebt}
        title={gT('acpk_multi_table_title')}
        withBackground
      />
      <Box className={classes.btnWrapper}>
        <Btn
          fullWidth
          component={RouterLink}
          to={`${portalRootUrl()}/deuda/${parentDebt.id}`}
        >
          Ver Detalles
        </Btn>
      </Box>
    </Box>
  );
};

const useStyles = makeStyles((theme: Theme) => createStyles({
  root: {
    backgroundColor: theme.palette.marble.main,
    padding: theme.spacing(2),
  },
  btnWrapper: {
    padding: theme.spacing(2, 4, 0),
  },
}));

export default AccordionNegOptionsAcpkChild;
